module.exports = __webpack_public_path__ + "static/media/logo-polar-night-2.189bae07.png";